<template>
    <div id="CodeExchange">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full">
                        <img src="./img/close.png"
                             @click="close"
                             class="close" />
                        <div class="title">常见问题</div>
                        <div class="qa_list">
                            <div class="qa_item"
                                 v-for="(item,index) in qa_list"
                                 :key="index">
                                <p class="title">{{index+1}}、{{item.title}}</p>
                                <p class="desc">{{item.desc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data () {
        return {
            qa_list: [{
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }, {
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }, {
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }, {
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }, {
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }, {
                id: 1,
                title: '什么是积分？',
                desc: '积分是 Midiournev绘画(中国) 中的基础计量单位，对于普通模式，基础会员1 积分可以画一慢图，而高级会员和超级会员则免积分出图；对于快速模式，所有会员 4 积分可以画一张快图。如果您需要进一步编辑图片，如扩图，放大，局部重绘等，也需要消耗积分。'
            }]
        }
    },
    created () {

    },
    methods: {
        close () {
            this.$store.commit('setShowQuestion', false)
        },

    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#CodeExchange {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        max-height: 90vh;
        overflow-y: auto;
        &::-webkit-scrollbar {
            display: none !important;
            width: 0 !important;
        }

        &::-webkit-scrollbar-thumb {
            height: 0px !important;
        }
        .con {
            width: 982px;
            padding: 47px;
            background-color: #1e1f22;
            border-radius: 5px;
            .full {
                position: relative;
                .close {
                    position: absolute;
                    right: -20px;
                    top: -20px;
                    width: 28px;
                    height: 28px;
                    padding: 6px;
                    cursor: pointer;
                }
                .title {
                    font-size: 20px;
                    font-weight: bold;
                    text-align: center;
                    color: #fff;
                    margin-bottom: 20px;
                }
                .qa_list {
                    max-height: 600px;
                    overflow: auto;
                    padding-right: 5px;
                    .qa_item {
                        padding: 18px;
                        background: #313338;
                        border-radius: 6px;
                        margin-bottom: 16px;
                        .title {
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 24px;
                            color: #f9f6f9;
                            margin-bottom: 14px;
                            text-align: left;
                        }
                        .desc {
                            font-size: 13px;
                            color: #b4b9bf;
                        }
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>